import { h } from 'vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { ArrowUpDown, ChevronDown } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { format } from 'date-fns' 
import { saveRowToDb } from '@/utils/globals';


export interface User {
  id: number;
  name: string;
  firstname: string;
  lastname: string;
  short: string;
  is_active: boolean;
  created_at: Date;
  updated_at: Date;
}

export const colsuser = [
  { key: "id", label: "ID", editable: false },
  { key: "name", label: "User", type: 'text', editable: true, required: true, textAlign: 'left' },
  { key: "password", label: "Kennwort", type: 'text', editable: true, required: false },
  { key: "firstname", label: "Vorname", type: 'text', editable: true, required: true, textAlign: 'left' },
  { key: "lastname", label: "Nachname", type: 'text', editable: true, required: true, textAlign: 'left' },
  { key: "short", label: "Kurzname", type: 'text', editable: true, required: true },  
  { key: "is_active", label: "Aktiv", type: 'select', options: [{id: 0, label: 'Nein'}, {id: 1, label: 'Ja'}],  editable: true, required: true },
  { key: "role_id", label: "Rolle", type: 'select', options: [], editable: true, required: true },
  { key: "created_at", label: "Erzeugt", type: 'date', editable: false, required: false },
  { key: "updated_at", label: "Geändert", type: 'date', editable: false, required: false },
];